export enum JobStatus {
  Completed = 1,
  Invoiced = 2,
  Closed = 3,
  Cancelled = 4,
  Created = 5,
  Started = 6,
  Paused = 7,
}
